// extracted by mini-css-extract-plugin
module.exports =  {"root":"euOq7QHi9rLLp7Tg63xe","label":"qEqvgFhA1z5q_YVBasCv","divider":"qkCsKhyMO4kdzgEdQGzK"};